module.exports = __webpack_public_path__ + "img/qlt.fde8eeea.jpg";